module.exports = __webpack_public_path__ + "static/sport/bgi-form.5dba915.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi-form.png
// module id = Op1d
// module chunks = 0